import { Component, Input } from '@angular/core';

import { HorseParticipantData, HorsePerformanceData } from '@cds/betting-offer/domain-specific/horse-racing/timeform';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { orderBy } from 'lodash-es';

@Component({
    selector: 'ms-horse-info-description',
    templateUrl: 'horse-info-description.html',
    standalone: false,
})
export class HorseInfoDescriptionComponent {
    @Input() participantInfo: HorseParticipantData;

    @Input() set performanceData(value: HorsePerformanceData[]) {
        if (value && value.length) {
            this.recentPositions = orderBy(value, (p) => new Date(p.meetingDate))
                .map((p) => p.positionOfficial)
                .join('-');
        } else {
            this.recentPositions = '';
        }
    }

    recentPositions = '';

    constructor(public sitecore: Sitecore) {}
}
